<template>
    <div class="youtube-video-container" v-bind:class="{ 'ready' : isPlayerDisplayed }">
        <button
        class="close-video"
        tabindex="0"
        v-el:close-bt
        v-on:click.stop.prevent="closeVideo"
        v-on:touchstart.stop.prevent="closeVideo"
        aria-label="Close Fullscreen Video">
            <img src="../assets/images/close-video.svg" data-fallback-src="../assets/images/close-video.png" alt="Close Fullscreen Video">
        </button>
        <div id="player" class="youtube-video" v-bind:class="{ '-default-preloader' : useDefaultPreloader }"></div>
    </div>
</template>

<script>
    import YouTubePlayer from 'youtube-player'
    import { setFullScreenVideoReady, closeFullscreenVideo } from '../vuex/actions'

    export default {
        vuex: {
            getters: {
                youtubeVideoId: state => state.youtubeVideoId,
                useDefaultPreloader: state => state.useDefaultPreloader,
                isMobileAgent: state => state.isMobileAgent,
                isFullscreenVideoReady: state => state.isFullscreenVideoReady,
                isFullscreenVideoOpened: state => state.isFullscreenVideoOpened
            },
            actions: {
                setFullScreenVideoReady,
                closeFullscreenVideo
            }
        },

        data: function () {
            return {
                player: false,
                isPlayerDisplayed: false,
                stateNames: {
                    '-1': 'unstarted',
                    0: 'ended',
                    1: 'playing',
                    2: 'paused',
                    3: 'buffering',
                    5: 'video cued'
                }
            }
        },

        ready: function () {
            let $this = this
            this.player = YouTubePlayer('player', {
                height: '390',
                width: '640',
                videoId: $this.youtubeVideoId,
                playerVars: {
                    'autoplay': 1,
                    'color': 'white',
                    'showinfo': 0,
                    'controls': 1,
                    'rel': 0,
                    'disablekb': 1,
                    'iv_load_policy': 3,
                    'enablejsapi': 1,
                    'wmode': 'transparent'
                }
            })

            this.play()

            this.$nextTick(function () {
                this.$set('isPlayerDisplayed', true)
                this.$els.closeBt.focus()
            })
        },

        methods: {
            'play': function (event) {
                let $this = this

                if (this.useDefaultPreloader) {
                    if (!this.isMobileAgent) this.player.playVideo()
                    $this.setFullScreenVideoReady()
                } else {
                    if (!this.isMobileAgent) this.player.playVideo()
                    this.player.on('stateChange', function (event) {
                        if ($this.stateNames[event.data] === 'playing') {
                            $this.setFullScreenVideoReady()
                        }
                    })
                }
            },

            'stop': function () {
                this.player.stopVideo()
            },

            'closeVideo': function () {
                this.stop()
                this.closeFullscreenVideo()
                this.$set('isPlayerDisplayed', false)
                this.$set('player', false)
            }
        }
    }
</script>

<style lang="scss">
    @import '../assets/sass/global';

    $close-bt-size: 46.06px;
    $close-bt-size-large: 51.19px;

    .youtube-video-container {
        transition: opacity .6s ease;
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 195;
        opacity: 0;

        .close-video {
            position: absolute;
            z-index: 197;
            top: $global-viewport-padding-mobile;
            right: $global-viewport-padding-mobile;
            width: $close-bt-size;
            height: $close-bt-size;

            img {
                width: 100%;
                height: 100%;
            }

            @include gridle_state(large) {
                width: $close-bt-size-large;
                height: $close-bt-size-large;
                top: $global-viewport-padding;
                right: $global-viewport-padding;
            }
        }

        .youtube-video {
            width: 100%;
            height: 100%;
            z-index: 150;
            position: fixed;
            top: 0;
            left: 0;

            &.-default-preloader {
                background-color: black;
            }
        }

        &.ready {
            opacity: 1;
        }
    }
</style>



// WEBPACK FOOTER //
// YoutubeVideo.vue?da3a45f2